import ACTIONS from "../../constants/actions";

export const addViewedNews = (data) => dispatch => {
	dispatch({
		type : ACTIONS.VIEWED_NEWS.ADD,
		data : data,
	});
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/viewed-news.js